/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description articleAndAskRelationUsingGet参数
 * @property `[articles]` 文章列表
 * @property `[groupId]` 圈子id
 * @property `[questions]` 问答列表
 */
export interface ParamsarticleAndAskRelationUsingGet {
  // queryParams
  /**
   * 文章列表
   */
  articles?: Array<string>;
  /**
   * 圈子id
   */
  groupId?: string;
  /**
   * 问答列表
   */
  questions?: Array<string>;
}
/**
 * @description groupsAllUsingGet参数
 * @property `[isAdmin]` 当前页码
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsgroupsAllUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  isAdmin?: boolean;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * membersVO
 */
export type ParamsBodygroupsGroupIdAddMemberUsingPut = models.GroupAddMembersVO;
/**
 * @description groupsGroupIdApprovalUsingPut参数
 * @property `groupId` 圈子id
 * @property `[status]` 审批状态（0不需要审批、1需要审批）
 */
export interface ParamsgroupsGroupIdApprovalUsingPut {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 审批状态（0不需要审批、1需要审批）
   */
  status?: number;
}
/**
 * @description groupsGroupIdAssignUsingPost参数
 * @property `groupId` 圈子id
 * @property `username` 用户名
 */
export interface ParamsgroupsGroupIdAssignUsingPost {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 用户名
   */
  username: string;
}
/**
 * @description groupsGroupIdAuditedAllOperaUsingPut参数
 * @property `groupId` 圈子id
 */
export interface ParamsgroupsGroupIdAuditedAllOperaUsingPut {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
}
/**
 * @description groupsGroupIdAuditedOperaListUsingPut参数
 * @property `groupId` 圈子id
 * @property `users` 申请人列表
 */
export interface ParamsgroupsGroupIdAuditedOperaListUsingPut {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 申请人列表
   */
  users: Array<string>;
}
/**
 * @description groupsGroupIdAuditedOperaUsingPut参数
 * @property `groupId` 圈子id
 * @property `agree` 是否同意加入，true为同意，false为不同意
 * @property `username` 申请人
 */
export interface ParamsgroupsGroupIdAuditedOperaUsingPut {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 是否同意加入，true为同意，false为不同意
   */
  agree: boolean;
  /**
   * 申请人
   */
  username: string;
}
/**
 * @description groupsGroupIdAuditedlistUsingGet参数
 * @property `groupId` 圈子id
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsgroupsGroupIdAuditedlistUsingGet {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description groupsGroupIdHotUsingGet参数
 * @property `groupId` 圈子id
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsgroupsGroupIdHotUsingGet {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description groupsGroupIdInviteUsingPost参数
 * @property `groupId` 圈子id
 * @property `username` 用户名，多个使用,隔开
 */
export interface ParamsgroupsGroupIdInviteUsingPost {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 用户名，多个使用,隔开
   */
  username: Array<string>;
}
/**
 * @description groupsGroupIdJoinUsingPost参数
 * @property `groupId` 圈子id
 * @property `join` 是否加入，true为加入，false为退出
 */
export interface ParamsgroupsGroupIdJoinUsingPost {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 是否加入，true为加入，false为退出
   */
  join: boolean;
}
/**
 * @description groupsGroupIdKickUsingPost参数
 * @property `groupId` 圈子id
 * @property `username` 用户名
 */
export interface ParamsgroupsGroupIdKickUsingPost {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 用户名
   */
  username: string;
}
/**
 * @description groupsGroupIdLastUsingGet参数
 * @property `groupId` 圈子id
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `type` 类型：1文章 2提问 3回答
 */
export interface ParamsgroupsGroupIdLastUsingGet {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 类型：1文章 2提问 3回答
   */
  type: number;
}
/**
 * @description groupsGroupIdUnorganizedUsingGet参数
 * @property `groupId` 圈子id
 * @property `[keywords]` keywords
 */
export interface ParamsgroupsGroupIdUnorganizedUsingGet {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * keywords
   */
  keywords?: string;
}
/**
 * @description groupsGroupIdUsersUsingGet参数
 * @property `groupId` 圈子id
 * @property `[orderBy]` 排序方式
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsgroupsGroupIdUsersUsingGet {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 排序方式
   */
  orderBy?: string;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description groupsGroupIdUsingGet参数
 * @property `groupId` 圈子id
 */
export interface ParamsgroupsGroupIdUsingGet {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
}
/**
 * groupSaveVO
 */
export type ParamsBodygroupsGroupIdUsingPut = models.GroupAddVO;
/**
 * @description groupsGroupIdVotelistUsingGet参数
 * @property `groupId` 圈子id
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsgroupsGroupIdVotelistUsingGet {
  // pathParams
  /**
   * 圈子id
   */
  groupId: number;
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description groupsJoinsUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsgroupsJoinsUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description groupsRelationUsingGet参数
 * @property `groupIds` 圈子id
 */
export interface ParamsgroupsRelationUsingGet {
  // pathParams
  /**
   * 圈子id
   */
  groupIds: string;
}
/**
 * @description groupsStickArticleOrQuestionIdUsingPut参数
 * @property `articleOrQuestionId` 文章或问答id
 * @property `groupId` 圈子id
 * @property `stickType` 1-置顶 0-取消置顶
 * @property `type` 1-文章 2-问答
 */
export interface ParamsgroupsStickArticleOrQuestionIdUsingPut {
  // pathParams
  /**
   * 文章或问答id
   */
  articleOrQuestionId: number;
  // queryParams
  /**
   * 圈子id
   */
  groupId: number;
  /**
   * 1-置顶 0-取消置顶
   */
  stickType: number;
  /**
   * 1-文章 2-问答
   */
  type: number;
}
/**
 * @description groupsUsingDelete参数
 * @property `ids` 圈子id列表，多个用,隔开
 */
export interface ParamsgroupsUsingDelete {
  // queryParams
  /**
   * 圈子id列表，多个用,隔开
   */
  ids: Array<number>;
}
/**
 * groupSaveVO
 */
export type ParamsBodygroupsUsingPost = models.GroupAddVO;
export class GroupApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 将文章/问题加入圈子
   * @param params ParamsarticleAndAskRelationUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public articleAndAskRelationUsingGet = (
    params: ParamsarticleAndAskRelationUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/articleAndAskRelation';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('articles' in params) p.query.articles = params.articles;
    if ('groupId' in params) p.query.groupId = params.groupId;
    if ('questions' in params) p.query.questions = params.questions;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取全部圈子
   * @param params ParamsgroupsAllUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultGroupVO
   */
  public groupsAllUsingGet = (
    params: ParamsgroupsAllUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultGroupVO> => {
    const path = '/api/groups/all';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('isAdmin' in params) p.query.isAdmin = params.isAdmin;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 批量添加圈子用户
   
   * @param data: ParamsBodygroupsGroupIdAddMemberUsingPut// membersVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdAddMemberUsingPut = (
    data: ParamsBodygroupsGroupIdAddMemberUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/addMember';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.membersVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 申请加入圈子免审批开关-打开/关闭
   * @param params ParamsgroupsGroupIdApprovalUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdApprovalUsingPut = (
    params: ParamsgroupsGroupIdApprovalUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/approval';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('status' in params) p.query.status = params.status;
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 指定某人为圈子管理员
   * @param params ParamsgroupsGroupIdAssignUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdAssignUsingPost = (
    params: ParamsgroupsGroupIdAssignUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/assign';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('username' in params) p.query.username = params.username;
    ajax.check(params.username, 'username');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 全部同意圈子加入申请
   * @param params ParamsgroupsGroupIdAuditedAllOperaUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdAuditedAllOperaUsingPut = (
    params: ParamsgroupsGroupIdAuditedAllOperaUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/auditedAllOpera';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 批量同意圈子加入申请
   * @param params ParamsgroupsGroupIdAuditedOperaListUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdAuditedOperaListUsingPut = (
    params: ParamsgroupsGroupIdAuditedOperaListUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/auditedOperaList';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('users' in params) p.query.users = params.users;
    ajax.check(params.users, 'users');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 同意或拒绝圈子加入申请
   * @param params ParamsgroupsGroupIdAuditedOperaUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdAuditedOperaUsingPut = (
    params: ParamsgroupsGroupIdAuditedOperaUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/auditedOpera';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('agree' in params) p.query.agree = params.agree;
    ajax.check(params.agree, 'agree');
    if ('username' in params) p.query.username = params.username;
    ajax.check(params.username, 'username');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取加入圈子的申请列表
   * @param params ParamsgroupsGroupIdAuditedlistUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSimpleUserInfo
   */
  public groupsGroupIdAuditedlistUsingGet = (
    params: ParamsgroupsGroupIdAuditedlistUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSimpleUserInfo> => {
    const path = '/api/groups/{groupId}/auditedlist';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 分页获取圈子热门文章
   * @param params ParamsgroupsGroupIdHotUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSingleArticleInfo
   */
  public groupsGroupIdHotUsingGet = (
    params: ParamsgroupsGroupIdHotUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSingleArticleInfo> => {
    const path = '/api/groups/{groupId}/hot';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 邀请加入圈子
   * @param params ParamsgroupsGroupIdInviteUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdInviteUsingPost = (
    params: ParamsgroupsGroupIdInviteUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/invite';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('username' in params) p.query.username = params.username;
    ajax.check(params.username, 'username');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 申请加入或者退出圈子
   * @param params ParamsgroupsGroupIdJoinUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdJoinUsingPost = (
    params: ParamsgroupsGroupIdJoinUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/join';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('join' in params) p.query.join = params.join;
    ajax.check(params.join, 'join');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据username踢出圈子
   * @param params ParamsgroupsGroupIdKickUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdKickUsingPost = (
    params: ParamsgroupsGroupIdKickUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}/kick';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('username' in params) p.query.username = params.username;
    ajax.check(params.username, 'username');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 分页获取圈子最新文章/提问/回答
   * @param params ParamsgroupsGroupIdLastUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResult
   */
  public groupsGroupIdLastUsingGet = (
    params: ParamsgroupsGroupIdLastUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResult> => {
    const path = '/api/groups/{groupId}/last';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 搜索所有未加入或未邀请的用户
   * @param params ParamsgroupsGroupIdUnorganizedUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListAdminUserInfo
   */
  public groupsGroupIdUnorganizedUsingGet = (
    params: ParamsgroupsGroupIdUnorganizedUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListAdminUserInfo> => {
    const path = '/api/groups/{groupId}/unorganized';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('keywords' in params) p.query.keywords = params.keywords;
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 分页查询圈子下的所有成员
   * @param params ParamsgroupsGroupIdUsersUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultGroupUserInfo
   */
  public groupsGroupIdUsersUsingGet = (
    params: ParamsgroupsGroupIdUsersUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultGroupUserInfo> => {
    const path = '/api/groups/{groupId}/users';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取圈子详情
   * @param params ParamsgroupsGroupIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultGroupVO
   */
  public groupsGroupIdUsingGet = (
    params: ParamsgroupsGroupIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultGroupVO> => {
    const path = '/api/groups/{groupId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 更新圈子
   
   * @param data: ParamsBodygroupsGroupIdUsingPut// groupSaveVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsGroupIdUsingPut = (
    data: ParamsBodygroupsGroupIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/{groupId}';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.groupSaveVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取投票问题列表
   * @param params ParamsgroupsGroupIdVotelistUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultVoteQuestionSimplePO
   */
  public groupsGroupIdVotelistUsingGet = (
    params: ParamsgroupsGroupIdVotelistUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultVoteQuestionSimplePO> => {
    const path = '/api/groups/{groupId}/votelist';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 分页获取加入的所有圈子
   * @param params ParamsgroupsJoinsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultGroupVO
   */
  public groupsJoinsUsingGet = (
    params: ParamsgroupsJoinsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultGroupVO> => {
    const path = '/api/groups/joins';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取用户与圈子关系
   * @param params ParamsgroupsRelationUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsRelationUsingGet = (
    params: ParamsgroupsRelationUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/relation';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.groupIds, 'groupIds');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 置顶/取消置顶圈子文章/问题
   * @param params ParamsgroupsStickArticleOrQuestionIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsStickArticleOrQuestionIdUsingPut = (
    params: ParamsgroupsStickArticleOrQuestionIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups/stick/{articleOrQuestionId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('groupId' in params) p.query.groupId = params.groupId;
    ajax.check(params.groupId, 'groupId');
    if ('stickType' in params) p.query.stickType = params.stickType;
    ajax.check(params.stickType, 'stickType');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    ajax.check(params.articleOrQuestionId, 'articleOrQuestionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 批量删除圈子
   * @param params ParamsgroupsUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsUsingDelete = (
    params: ParamsgroupsUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('ids' in params) p.query.ids = params.ids;
    ajax.check(params.ids, 'ids');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 新增圈子
   
   * @param data: ParamsBodygroupsUsingPost// groupSaveVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public groupsUsingPost = (
    data: ParamsBodygroupsUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/groups';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.groupSaveVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new GroupApi();
